import { Suspense } from 'react'
import { ObjectStorageSwitcherFallback } from '@/components/layout/breadcrumbs/object-storage/object-storage-switcher/fallback'
import { ObjectStorageSwitcherData } from '@/components/layout/breadcrumbs/object-storage/object-storage-switcher/switcher'

export const ObjectStorageSwitcher = () => (
  <Suspense fallback={<ObjectStorageSwitcherFallback />}>
    <ObjectStorageSwitcherData />
  </Suspense>
)
